import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "@/components/layout";
import { PageLoader } from "@/components/ui";
import { HomePage } from "@/pages/home-page";
import {
  TextToImagePage,
  ImageEditPage,
  TextToVideoPage,
  ImageToVideoPage,
  ExtendVideoPage,
} from "@/pages/create";
import { GeneratePage } from "@/pages/generate-page";
import { AssetsPage } from "@/pages/assets-page";
import { ExplorePage } from "@/pages/explore-page";
import { FreeGenPage } from "@/pages/free-gen-page";

const BillingPage = lazy(() =>
  import("@/pages/billing-page").then((m) => ({ default: m.BillingPage })),
);
const AffiliatesPage = lazy(() =>
  import("@/pages/affiliates-page").then((m) => ({ default: m.AffiliatesPage })),
);
const SupportPage = lazy(() =>
  import("@/pages/support-page").then((m) => ({ default: m.SupportPage })),
);
const TermsPage = lazy(() =>
  import("@/pages/terms-page").then((m) => ({ default: m.TermsPage })),
);
const PromptingGuidePage = lazy(() =>
  import("@/pages/prompting-guide-page").then((m) => ({
    default: m.PromptingGuidePage,
  })),
);
const PrivacyPage = lazy(() =>
  import("@/pages/privacy-page").then((m) => ({ default: m.PrivacyPage })),
);
const RefundPage = lazy(() =>
  import("@/pages/refund-page").then((m) => ({ default: m.RefundPage })),
);
const MonetizePage = lazy(() =>
  import("@/pages/monetize-page").then((m) => ({ default: m.MonetizePage })),
);
const UserCreationsPage = lazy(() =>
  import("@/pages/user-creations-page").then((m) => ({
    default: m.UserCreationsPage,
  })),
);

function AppRoutes() {
  return (
    <MainLayout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/create/text-to-image" element={<TextToImagePage />} />
          <Route path="/create/image-edit" element={<ImageEditPage />} />
          <Route path="/create/text-to-video" element={<TextToVideoPage />} />
          <Route path="/create/image-to-video" element={<ImageToVideoPage />} />
          <Route path="/free-gen" element={<FreeGenPage />} />
          <Route path="/create/audio-video" element={<Navigate to="/create/image-to-video" replace />} />
          <Route path="/create/extend-video" element={<ExtendVideoPage />} />
          <Route path="/create" element={<Navigate to="/create/text-to-image" replace />} />
          <Route path="/generation/:id" element={<GeneratePage />} />
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/affiliates" element={<AffiliatesPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/prompting-guide" element={<PromptingGuidePage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund-policy" element={<RefundPage />} />
          <Route path="/monetize" element={<MonetizePage />} />
          <Route path="/user-creations" element={<UserCreationsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}

export function App() {
  return <AppRoutes />;
}
